import { SVGProps } from 'react';

export const StickyNoteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 9.97472C3 5.01514 7.03242 1 12 1C16.9676 1 21 5.01514 21 9.97472C21 13.9087 18.463 17.2469 14.9369 18.4604C14.6346 18.9694 14.1774 19.6445 13.7894 20.2039C13.5308 20.5769 13.2861 20.9223 13.1062 21.1742C13.0162 21.3003 12.9422 21.4032 12.8907 21.4748L12.8308 21.5577L12.8097 21.5869L12 21L11.1905 21.5871L11.1689 21.5573L11.109 21.4742C11.0573 21.4025 10.9833 21.2994 10.8932 21.1731C10.7131 20.9207 10.4681 20.5747 10.2093 20.2014C9.8216 19.6422 9.36486 18.9678 9.0633 18.4605C5.53708 17.2471 3 13.9088 3 9.97472ZM12 21L11.1905 21.5871L11.9997 22.7026L12.8097 21.5869L12 21ZM12.0002 19.2736C12.0481 19.2051 12.0968 19.1352 12.1459 19.0642C12.6699 18.3086 13.1872 17.5294 13.3627 17.1794L13.5579 16.7902L13.9758 16.668C16.8824 15.8177 19 13.14 19 9.97472C19 6.12567 15.869 3 12 3C8.13102 3 5 6.12567 5 9.97472C5 13.14 7.11757 15.8177 10.0242 16.668L10.4421 16.7902L10.6373 17.1794C10.8112 17.5261 11.3283 18.3051 11.8529 19.0619C11.9026 19.1336 11.9519 19.2044 12.0002 19.2736Z"
      fill={props.fill ?? 'white'}
    />
    <path d="M8 13H13V11H8V13Z" fill={props.fill ?? 'white'} />
    <path d="M8 9H16V7H8V9Z" fill={props.fill ?? 'white'} />
  </svg>
);

export default StickyNoteIcon;
